var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"compare",attrs:{"id":"compare"}},[_c('h2',[_vm._v("Compare Our Plans")]),_vm._v(" "),_c('p',[_vm._v("See which plan is best for you by comparing the features offered.")]),_vm._v(" "),_c('PricingCompareTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }